// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","container":"App_container__4L7Vo","content":"App_content__naSmy","menu":"App_menu__M8k5S"};